export default `
  query getProductFilters($search: String = "", $filter: ProductAttributeFilterInput, $pageSize: Int = 20, $currentPage: Int = 1) {
    products(search: $search, filter: $filter, pageSize: $pageSize, currentPage: $currentPage) {
      aggregations {
        label
        count
        attribute_code
        options {
          count
          label
          value
          __typename
        }
        position
        __typename
      }
      __typename
    }
  }
`;
